import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";
import logoHas from "../../../assets/images/LOGO HAS.png";
import logoBtn from "../../../assets/images/btn.png";
import logoCms from "../../../assets/images/LOGO CMS.png";
import logoWAP from "../../../assets/images/LOGO WAP.png";
import logoNSP from "../../../assets/images/LOGO NSP.png";

import logoTtdNSP from "../../../assets/images/logoTtdNSP.png";
import logoTtdWAP from "../../../assets/images/logoTtdWAP.png";
import logoTtdHAS from "../../../assets/images/logoTtdHAS.png";
import logoTtdCMS from "../../../assets/images/logoTtdCMS.png";

export const ButtonPrintSPR = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocSPR = ({ innerRef, item, type, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("D MMM YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return !item || item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 40px 40px 40px" }}>
        <div
          style={{
            // border: "1px solid #000000",
            lineHeight: "1.2",
            display: "flex",
            alignItems: "center",
            padding: "5px 0",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          <div
            style={{
              marginTop: "15px",
              paddingLeft: "20px",
              paddingRight: "40px",
              flex: "1",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}>{companyName}
            <div style={{ textAlign: "center", fontWeight: "normal", padding: "0" }}>{item && item.sales_branch && item.sales_branch.name}</div>
            <p
              style={{
                fontSize: "14px",
                textAlign: "center",
                fontWeight: "normal",
                padding: "0",
                // lineHeight: "0"
              }}>
              {item.sales_branch?.branch_address[0]?.description}
            </p>
          </div>
        </div>
        <div
          style={{
            textAlign: "center",
            textDecoration: "underline",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          SURAT PESANAN RUMAH (SPR)
        </div>
        <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
          <table style={{ borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1.2" }}>
            <tbody>
              <tr>
                <td rowSpan={11} style={{ width: "40px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>
                  I.
                </td>
                <td colSpan={3} style={{ fontWeight: "bold" }}>
                  DATA PRIBADI
                </td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", width: "150px" }}>TANGGAL PEMESANAN</td>
                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                <td>{handleValidDate(item.transactionat)}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", width: "150px" }}>ATAS NAMA</td>
                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                <td>{item.sales_customer.name}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", width: "150px" }}>ALAMAT</td>
                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                <td>{item.sls_appl && item.sls_appl.address && item.sls_appl.address}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", width: "150px" }}>KOTA / PROVINSI</td>
                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                <td>{item.sls_appl && item.sls_appl.city && item.sls_appl.city}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", width: "150px" }}>NO. IDENTITAS (KTP)</td>
                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                <td>{item.sls_appl && item.sls_appl.identity}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", width: "150px" }}>TELP / HP</td>
                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                <td>{item.sls_appl && item.sls_appl.phone}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", width: "150px" }}>NAMA INSTANSI</td>
                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                <td>{item.sls_appl && item.sls_appl.job_business_name}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", width: "150px" }}>ALAMAT</td>
                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                <td>{item.sls_appl && item.sls_appl.job_business_address}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", width: "150px" }}>KOTA / PROVINSI</td>
                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                <td>{item.sls_appl && item.sls_appl.job_business_city}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", width: "150px" }}>TAHUN PEMBANGUNAN</td>
                <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                <td>{item.sales_detail[0]?.sales_detail_product?.production_year}</td>
              </tr>
            </tbody>
          </table>
          <div
            style={{
              marginTop: "10px",
              display: "flex",
            }}><table
              style={{
                borderCollapse: "collapse",
                tableLayout: "fixed",
                lineHeight: "1.2",
              }}>
              <tbody>
                <tr>
                  <td rowSpan={3} style={{ width: "40px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>
                    II.
                  </td>
                  <td colSpan={4} style={{ fontWeight: "bold" }}>
                    DATA KAVLING
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>a.</td>
                  <td style={{ verticalAlign: "top", width: "110px" }}>Type</td>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                  <td style={{ fontWeight: "bold" }}>{item.sales_detail[0]?.name.substr(0, 10)}</td>
                </tr>
                <tr>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>b.</td>
                  <td style={{ verticalAlign: "top", width: "110px" }}>Blok Kavling</td>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                  <td style={{ fontWeight: "bold" }}>{item.sales_detail[0]?.name.substr(-6)}</td>
                </tr>
              </tbody>
            </table>
            <table
              style={{
                borderCollapse: "collapse",
                tableLayout: "fixed",
                lineHeight: "1.2",
              }}>
              <tbody>
                <tr>
                  <td rowSpan={3} style={{ width: "40px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top", height: "21.5px" }}></td>
                  <td colSpan={4} style={{ fontWeight: "bold", height: "21.5px" }}></td>
                </tr>
                <tr>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>c.</td>
                  <td style={{ verticalAlign: "top", width: "110px" }}> Luas Bangunan</td>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                  <td style={{ fontWeight: "bold" }}> 30 m²</td>
                </tr>
                <tr>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>d.</td>
                  <td style={{ verticalAlign: "top", width: "110px" }}> Luas Tanah</td>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                  <td style={{ fontWeight: "bold" }}> 60 m²</td>
                </tr>
              </tbody>
            </table>
          </div>
          <table
            style={{
              marginTop: "10px",
              borderCollapse: "collapse",
              tableLayout: "fixed",
              width: "100%",
              lineHeight: "1.2",
            }}><tbody>
              <tr>
                <td rowSpan={15} style={{ width: "40px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>
                  III.
                </td>
                <td
                  colSpan={3}
                  style={{
                    fontWeight: "bold",
                  }}>
                  PERHITUNGAN HARGA JUAL DAN KPR
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #000000",
                    textAlign: "center",
                    padding: "10px 0",
                    fontWeight: "bold",
                  }}>
                  Keterangan
                </td>
                <td
                  style={{
                    border: "1px solid #000000",
                    textAlign: "center",
                    padding: "10px 0",
                    fontWeight: "bold",
                  }}>
                  Penjelasan
                </td>
                <td
                  style={{
                    border: "1px solid #000000",
                    textAlign: "center",
                    padding: "10px 0",
                    fontWeight: "bold",
                  }}>
                  Rp.
                </td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Harga Jual</td>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>{currencyFormat(item.sales_detail[0]?.amount)}</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Uang Muka</td>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>{currencyFormat(item.sales_detail[0]?.amount * (1 / 100))}</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>PPH (HOOK)</td>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>-</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>BPHTB (HOOK)</td>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>-</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>SBUM (Subsidi Bantuan Uang Muka)</td>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>{currencyFormat(item.sales_branch.sbum)}</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Maksimal KPR</td>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>{currencyFormat(item.sales_detail[0]?.amount - item.sales_detail[0]?.amount * (1 / 100) - item.sales_branch.sbum)}</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Biaya Administrasi dan Proses</td>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>{currencyFormat(item.sales_detail[0]?.sales_detail_product?.price_cogs)}</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Peningkatan Mutu</td>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>-</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Tabungan Mengendap</td>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>-</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Booking Fee</td>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>{currencyFormat(item.book_amount)}</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Total yang harus dibayar</td>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>{currencyFormat(parseFloat(item.sales_detail[0]?.price_handling) + parseFloat(item.book_amount))}</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Cicilan Uang Muka 1</td>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>-</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>Sisa yang harus dibayar</td>
                <td style={{ border: "1px solid #000000", padding: "0 10px" }}>""</td>
                <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}>-</td>
              </tr>
            </tbody>
          </table>

          <div
            style={{
              display: "flex",
              alignItems: "start",
              gap: "10px",
            }}><div style={{ width: "100%" }}>
              <table
                style={{
                  marginTop: "10px",
                  borderCollapse: "collapse",
                  tableLayout: "fixed",
                  width: "100%",
                  lineHeight: "1.2",
                }}>
                <tbody>
                  <tr>
                    <td rowSpan={15} style={{ width: "40px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>
                      IV.
                    </td>
                    <td colSpan={3} style={{ fontWeight: "bold" }}>
                      PERINCIAN PEMBAYARAN CICILAN UANG MUKA
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid #000000", textAlign: "center", padding: "10px 0", fontWeight: "bold" }}>Tanggal Jatuh Tempo</td>
                    <td style={{ border: "1px solid #000000", textAlign: "center", padding: "10px 0", fontWeight: "bold" }}>Pembayaran</td>
                    <td style={{ border: "1px solid #000000", textAlign: "center", padding: "10px 0", fontWeight: "bold" }}>Tanggal Cicil</td>
                    <td style={{ border: "1px solid #000000", textAlign: "center", padding: "10px 0", fontWeight: "bold" }}>Sisa Cicilan</td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid #000000", padding: "0 10px" }}>-</td>
                    <td style={{ border: "1px solid #000000", padding: "0 10px" }}></td>
                    <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}></td>
                    <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}></td>
                  </tr>
                  <tr>
                    <td colSpan={3} style={{ border: "1px solid #000000", padding: "0 10px" }}>
                      -
                    </td>
                    <td style={{ border: "1px solid #000000", textAlign: "end", padding: "0 10px" }}></td>
                  </tr>
                </tbody>
              </table>
              <table
                style={{
                  borderCollapse: "collapse",
                  tableLayout: "fixed",
                  lineHeight: "1.2",
                }}>
                <tbody>
                  <tr>
                    <td rowSpan={4} style={{ width: "40px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}></td>
                    <td colSpan={2} style={{ fontWeight: "bold" }}>

                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>1.</td>
                    <td style={{ verticalAlign: "top", width: "250px" }}>Putih Untuk Bank</td>
                  </tr>
                  <tr>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>2.</td>
                    <td style={{ verticalAlign: "top", width: "250px" }}>Merah Untuk Konsumen</td>
                  </tr>
                  <tr>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>3.</td>
                    <td style={{ verticalAlign: "top", width: "250px" }}>Kuning Untuk Arsip</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              style={{
                marginTop: "25px",
                width: "250px",
                textAlign: "center",
              }}>
              <div>Bogor, {handleValidDate()}</div>
              <div>Konsumen</div>
              <div
                style={{
                  marginTop: "60px",
                  fontWeight: "bold",
                }}>
                {item.sales_customer.name}
              </div>
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <div>Developer</div>
                <div style={{ textAlign: "center", padding: "10px 0px" }}>
                  <img src={companyValue === 1 || companyValue === 4 ? logoTtdHAS : companyValue === 2 ? logoTtdCMS : logoTtdWAP } width={90} alt="" style={{ marginRight: "5px" }} />
                </div>
                <div style={{ fontWeight: "bold" }}>( {companyName} )</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
